const FETCH_SPECIAL_OFFERS_CREATOR_REQUEST = 'FETCH_SPECIAL_OFFERS_CREATOR_REQUEST'
const FETCH_SPECIAL_OFFERS_CREATOR_SUCCESS = 'FETCH_SPECIAL_OFFERS_CREATOR_SUCCESS'
const FETCH_SPECIAL_OFFERS_CREATOR_FAILURE = 'FETCH_SPECIAL_OFFERS_CREATOR_FAILURE'
const UPDATE_SELECTED_PRODUCTS = 'UPDATE_SELECTED_PRODUCTS'

export {
  FETCH_SPECIAL_OFFERS_CREATOR_REQUEST,
  FETCH_SPECIAL_OFFERS_CREATOR_SUCCESS,
  FETCH_SPECIAL_OFFERS_CREATOR_FAILURE,
  UPDATE_SELECTED_PRODUCTS
}
